import * as React from 'react';

export const SearchIcon = () => {
    return (
        <svg data-name='Group 104' xmlns='http://www.w3.org/2000/svg' fill='currentColor' viewBox='0 0 20 20' aria-hidden='true'>
            <path data-name='Path 330' d='M14.606 13.166l5.1 5.1a1.02 1.02 0 01-1.442 1.443l-5.1-5.1a8.162 8.162 0 111.442-1.443zm-2.119-.677a6.12 6.12 0 10-8.655 0 6.122 6.122 0 008.655 0z' fill='inherit'/>
        </svg>
    );
};
